import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';

import { CAPTCHA, RecaptchaPopupComponent } from './components';
import { CAPTCHA_GUARDS } from './guards';

@NgModule({
  imports: [
    RecaptchaModule.forRoot(),
    CommonModule,
    RecaptchaModule
  ],
  declarations: [CAPTCHA],
  exports: [CAPTCHA],
  providers: [CAPTCHA_GUARDS],
  entryComponents: [RecaptchaPopupComponent]
})
export class CaptchaModule {
  static forRoot(settings: RecaptchaSettings): ModuleWithProviders {
    return {
      ngModule: CaptchaModule,
      providers: [
        { provide: RECAPTCHA_SETTINGS, useValue: settings }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/captcha/captcha.module.ts